// src/pages/onboarddeboard/employees/performance/page.js

import React, { useState } from "react";

// ─── Static Mock Data ─────────────────────────────────────────────────────────

const MOCK_PERFORMANCE = [
  { id: 1,  employeeName: "Aarav Sharma",    empId: "EMP001", department: "Engineering", rating: 4.8, goalCompletion: 95, status: "Reviewed" },
  { id: 2,  employeeName: "Priya Mehta",     empId: "EMP002", department: "Design",      rating: 4.5, goalCompletion: 88, status: "Reviewed" },
  { id: 3,  employeeName: "Rohit Verma",     empId: "EMP003", department: "Engineering", rating: 3.9, goalCompletion: 72, status: "Pending"  },
  { id: 4,  employeeName: "Sneha Patil",     empId: "EMP004", department: "HR",          rating: 4.2, goalCompletion: 80, status: "Reviewed" },
  { id: 5,  employeeName: "Karan Joshi",     empId: "EMP005", department: "Testing",     rating: 4.6, goalCompletion: 91, status: "Reviewed" },
  { id: 6,  employeeName: "Divya Nair",      empId: "EMP006", department: "Engineering", rating: 3.5, goalCompletion: 65, status: "Pending"  },
  { id: 7,  employeeName: "Amit Kulkarni",   empId: "EMP007", department: "Sales",       rating: 4.1, goalCompletion: 78, status: "Reviewed" },
  { id: 8,  employeeName: "Pooja Desai",     empId: "EMP008", department: "Finance",     rating: 4.7, goalCompletion: 93, status: "Reviewed" },
  { id: 9,  employeeName: "Vikas Rao",       empId: "EMP009", department: "Engineering", rating: 3.8, goalCompletion: 70, status: "Pending"  },
  { id: 10, employeeName: "Ananya Singh",    empId: "EMP010", department: "Marketing",   rating: 4.4, goalCompletion: 85, status: "Reviewed" },
  { id: 11, employeeName: "Rahul Gupta",     empId: "EMP011", department: "Engineering", rating: 4.3, goalCompletion: 82, status: "Reviewed" },
  { id: 12, employeeName: "Meera Iyer",      empId: "EMP012", department: "Design",      rating: 3.6, goalCompletion: 68, status: "Pending"  },
];

// ─── Constants ────────────────────────────────────────────────────────────────

const AVATAR_COLORS = ["#3b82f6","#8b5cf6","#10b981","#f59e0b","#ef4444","#6366f1"];

// ─── Helpers ──────────────────────────────────────────────────────────────────

const getInitials = (name) => {
  if (!name) return "?";
  return name.trim().split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);
};

const ratingColor = (r) => {
  if (r >= 4.5) return "#2563eb";
  if (r >= 4.0) return "#16a34a";
  if (r >= 3.5) return "#f59e0b";
  return "#ef4444";
};

// ─── Main Component ───────────────────────────────────────────────────────────

const Performance = () => {
  const [employees]    = useState(MOCK_PERFORMANCE);
  const [searchTerm,   setSearchTerm]   = useState("");
  const [statusFilter, setStatusFilter] = useState("All status");

  // ── Stat counts from static data ──
  const avgRating        = (employees.reduce((s, e) => s + e.rating, 0) / employees.length).toFixed(1);
  const reviewsCompleted = employees.filter((e) => e.status === "Reviewed").length;
  const pendingReviews   = employees.filter((e) => e.status === "Pending").length;

  // ── Filter ──
  const filtered = employees.filter((e) => {
    const matchSearch =
      (e.employeeName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (e.department   || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (e.empId        || "").toLowerCase().includes(searchTerm.toLowerCase());
    const matchStatus = statusFilter === "All status" || e.status === statusFilter;
    return matchSearch && matchStatus;
  });

  return (
    <div style={{ padding: "16px", fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", background: "#f8f9fa", minHeight: "100vh" }}>

      {/* ── Header ── */}
      <div style={{ marginBottom: 24 }}>
        <h2 className="page-main-heading">Performance</h2>
<p className="page-sub-heading">Track employee performance reviews and goals</p>

      </div>

      {/* ── Stat Cards ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 16, marginBottom: 24 }}>
        {[
          { label: "Avg. Rating",       value: avgRating,        border: "#3b82f6" },
          { label: "Reviews Completed", value: reviewsCompleted, border: "#22c55e" },
          { label: "Pending Reviews",   value: pendingReviews,   border: "#f59e0b" },
        ].map((card) => (
          <div key={card.label} style={{
            background: "#fff", borderRadius: 10, padding: "20px 24px",
            borderTop: `4px solid ${card.border}`, boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          }}>
            <div style={{ fontSize: 32, fontWeight: 700, color: "#1a1a2e" }}>{card.value}</div>
            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>{card.label}</div>
          </div>
        ))}
      </div>

      {/* ── Filters ── */}
      <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <input
          placeholder="Search employees..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ flex: 1, minWidth: 200, border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 14px", fontSize: 14, outline: "none" }}
        />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 14px", fontSize: 14, background: "#fff", cursor: "pointer" }}
        >
          {["All status", "Reviewed", "Pending"].map((s) => (
            <option key={s}>{s}</option>
          ))}
        </select>
      </div>

      {/* ── Table ── */}
      <div style={{ background: "#fff", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 600 }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #f3f4f6" }}>
              {["Employee", "Department", "Rating", "Goal Completion", "Status"].map((h) => (
                <th key={h} style={{ padding: "14px 16px", textAlign: "left", fontSize: 13, fontWeight: 600, color: "#6b7280" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: 32, textAlign: "center", color: "#9ca3af" }}>No records found</td>
              </tr>
            ) : (
              filtered.map((e, i) => (
                <tr key={e.id} style={{ borderBottom: "1px solid #f9fafb" }}
                  onMouseEnter={(ev) => ev.currentTarget.style.background = "#fafafa"}
                  onMouseLeave={(ev) => ev.currentTarget.style.background = "transparent"}
                >
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{
                        width: 36, height: 36, borderRadius: "50%",
                        background: AVATAR_COLORS[i % AVATAR_COLORS.length],
                        color: "#fff", display: "flex", alignItems: "center",
                        justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0,
                      }}>
                        {getInitials(e.employeeName)}
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 14, color: "#1a1a2e" }}>{e.employeeName}</div>
                        <div style={{ fontSize: 12, color: "#9ca3af" }}>{e.empId}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "14px 16px", fontSize: 14, color: "#374151" }}>{e.department}</td>
                  <td style={{ padding: "14px 16px" }}>
                    <span style={{ color: ratingColor(e.rating), fontWeight: 700, fontSize: 14 }}>{e.rating}</span>
                    <span style={{ color: "#9ca3af", fontSize: 13 }}>/5</span>
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ flex: 1, background: "#e5e7eb", borderRadius: 99, height: 8, minWidth: 80 }}>
                        <div style={{ width: `${e.goalCompletion}%`, background: "#2563eb", borderRadius: 99, height: 8 }} />
                      </div>
                      <span style={{ fontSize: 13, color: "#374151", whiteSpace: "nowrap" }}>{e.goalCompletion}%</span>
                    </div>
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <span style={{
                      background: e.status === "Reviewed" ? "#e6f4ea" : "#fff8e1",
                      color:      e.status === "Reviewed" ? "#2e7d32" : "#f59e0b",
                      borderRadius: 12, padding: "2px 12px", fontSize: 12, fontWeight: 600,
                    }}>
                      {e.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Performance;